const DEFAULT_SIZE = 25;

export function getLqipDimensions(ratio?: number): [number, number] {
  // If no ratio is provided, return a square image
  if (!ratio) return [DEFAULT_SIZE, DEFAULT_SIZE];

  // Set a fixed size for the width
  const width = DEFAULT_SIZE;

  // Scale the height by dividing the width by the ratio. Round to the nearest integer.
  const scaledHeight = Math.round(width / ratio);

  return [width, scaledHeight];
}
